<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">Stock Issued Summary Report</h4>
                <p class="text-subtitle-1">Issued Items within a date range</p>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-form ref="form">

            <v-row align="center" class="my-2">
                <!-- <v-col>
                    <v-autocomplete
                        auto-select-first
                        label="Warehouse"
                        item-text="display_name"
                        item-value="id"
                        :items="warehouses"
                        v-model="form.warehouse_id"
                        @update:search-input="fetchWarehouses"
                        :loading="warehousesLoading"
                        outlined
                        :rules="[isRequired]"
                        dense
                        hide-details>
                    </v-autocomplete>
                </v-col> -->
                <v-col cols="12" md="3">
                    <DatePicker
                        label="From"
                        v-model="form.start_at"
                        outlined
                        dense
                        :rules="[isRequired]"
                        hide-details/>
                </v-col>
                <v-col cols="12" md="3">
                    <DatePicker
                        label="to"
                        v-model="form.end_at"
                        outlined
                        :rules="[isRequired]"   
                        dense
                        hide-details/>
                </v-col>
                <v-col cols="12" md="3">
                    <v-btn color="primary" block @click="fetchAsync" :loading="loading">
                        <v-icon left>mdi-magnify</v-icon>
                        search
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
        <v-row no-gutters>
            <v-col>
                <v-text-field
                    label="Filter Result"
                    filled
                    single-line
                    dense
                    hide-details="auto"
                    v-model="filter"
                    prepend-inner-icon="mdi-filter"
                    clearable>
                </v-text-field>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col>
                <v-progress-linear indeterminate v-if="loading"/>
                <v-simple-table dense>
                    <thead class="py-2">
                        <tr>
                            <th>#</th>
                            <th>Item Code</th>
                            <th>Item Name</th>
                            <th>Quantity</th>
                            <th>Unit</th>
                            <th>Value</th>
                            <th>Avg Cost</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(d, i) in filteredData" :key="i">
                            <td>{{ i + 1}}</td>
                            <td>{{d.item_code}}</td>
                            <td>{{d.item_name}}</td>
                            <td>{{formatNumber(d.quantity, 2)}}</td>
                            <td>{{d.abbreviation}}</td>
                            <td>{{formatNumber(d.value, 2)}}</td>
                            <td>{{formatNumber(d.value / d.quantity, 2)}}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import DatePicker from './../../components/common/DatePicker.vue'
import moment from 'moment';
import reports from './../../services/warehouse/reports'
import warehouse from './../../services/warehouse/warehouse';
import { isRequired } from './../../utils/validations';
import { formatNumber } from 'accounting';

export default {
    components: {
        DatePicker
    },
    data() {
        return {
            form: {
                warehouse_id: null,
                start_at: moment().format("YYYY-MM-DD"),
                end_at: moment().format("YYYY-MM-DD")
            },
            data: [],
            warehouses: [],
            warehousesLoading: false,
            loading: false,
            filter: ""
        }
    },
    computed: {
        filteredData() {
            if(!this.filter) return this.data
            return this.data.filter((each) => {
                return (
                    each.item_code.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
                    each.item_name.toLowerCase().indexOf(this.filter.toLowerCase()) > -1
                )
            })
        }
    },
    methods: {
        isRequired,
        formatNumber,
        fetchAsync() {
            if(!this.$refs.form.validate()) return;
            this.loading = true;
            this.data = [];
            reports.issuedItems(this.form).then(response => {
                this.data = response.data
            }).finally(() => {
                this.loading = false;
            })
        },
        fetchWarehouses(query) {
            this.warehousesLoading = true;
            warehouse.search(query).then(response => {
                this.warehouses = Array.from(new Set(...this.warehouses, response.data))
            }).finally(() => {
                this.warehousesLoading = false
            })
        }
    },
    created() {
       this.form.warehouse_id = this.$route.params.warehouseId
    }
}
</script>

<style>

</style>